import React from 'react';
import { Card } from 'antd';
import WorkOrderTable from '../WorkOrderTable';
import { EmptyState } from '../empty_state/EmptyState';
import WorkOrderTableRowWithoutActions from '../work_order_table_row_without_actions/WorkOrderTableRowWithoutActions';
import { ShowAllFooterWorkOrders } from '../WorkOrderTable/TableFooter';
import { WORK_ORDER_DISPLAY_STATUSES } from '../../constants/WorkOrderDisplayStatuses';

const LOCATION_ASSOCIATED_INACTIVE_WORK_ORDERS_TARGET_COLLECTION =
	'FETCH_DATA_FROM_SERVER_locationAssociatedInActiveWorkOrders';
const DEFAULT_BACK_TEXT = 'Back to location';

export default function LocationWorkHistory({
	contractorTenantId,
	locationId,
	showActions = true,
}) {
	return (
		<Card title="Work History">
			<WorkOrderTable
				CustomHeader={() => <></>}
				CustomWorkOrderRowDisplay={showActions ? undefined : WorkOrderTableRowWithoutActions}
				preAppliedFilters={{
					...(locationId && {
						locationIds: [locationId],
					}),
					...(contractorTenantId && { contractorTenantId }),
					displayStatuses: [
						WORK_ORDER_DISPLAY_STATUSES.complete,
						WORK_ORDER_DISPLAY_STATUSES.cancelled,
					],
				}}
				tableStyle={{
					display: 'flex',
					flexDirection: 'column',
					cursor: 'pointer',
					userSelect: 'none',
					marginTop: '-10px',
					marginBottom: '-9px',
				}}
				initialPagination={{ current: 1, pageSize: 3 }}
				targetCollectionName={LOCATION_ASSOCIATED_INACTIVE_WORK_ORDERS_TARGET_COLLECTION}
				renderEmptyState={() => (
					<EmptyState
						graphic={
							<img
								alt="There aren't any past work orders."
								style={{ marginBottom: 8 }}
								src="https://s3.amazonaws.com/mock-data-assets/categories/images/cactus.svg"
							/>
						}
						headline={'No news is good news.'}
						body={
							<div style={{ textAlign: 'center' }}>
								<div style={{ maxWidth: 440, marginBottom: 16 }}>
									There aren't any past work orders.
								</div>
							</div>
						}
					/>
				)}
				backText={DEFAULT_BACK_TEXT}
				openMoreInDefault
				ignoreRefreshCounts
				CustomFooter={ShowAllFooterWorkOrders}
			/>
		</Card>
	);
}
